import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import MatchesSection from './components/MatchesSection';
import StatsSection from './components/StatsSection';
import ActivitiesSection from './components/ActivitiesSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '开云足球·官方落地页｜极致足球体验平台',
            description:
              '开云足球是专注足球赛事、数据分析与互动体验的综合平台。无论您是足球爱好者还是专业玩家，开云足球为您提供实时赛事资讯、精准数据支持与沉浸式足球互动服务。',
            url: 'https://kaiyun-football.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '开云足球',
              url: 'https://kaiyun-football.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://kaiyun-football.com/',
                },
              ],
            },
          }),
        }}
      />
      <HeroSection />
      <ServicesSection />
      <MatchesSection />
      <StatsSection />
      <ActivitiesSection />
      <ArticlesSection />
      <CTASection />
      <NewsletterSection />
    </>
  );
}